'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.treeNodeProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _checkbox = require('../../checkbox/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _icon = require('../../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _index = require('../../../utils/index');

require('./tree-node.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TreeNode = function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  function TreeNode(props) {
    _classCallCheck(this, TreeNode);

    var _this = _possibleConstructorReturn(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));

    _this.onCheck = _this.onCheck.bind(_this);
    _this.onExpand = _this.onExpand.bind(_this);
    return _this;
  }

  _createClass(TreeNode, [{
    key: 'onCheck',
    value: function onCheck() {
      var _props = this.props,
          checked = _props.checked,
          entity = _props.entity,
          value = _props.value,
          optimisticToggle = _props.optimisticToggle,
          rawChildren = _props.rawChildren,
          onCheck = _props.onCheck;

      var isChecked = false;

      // Toggle off state to checked
      if (checked === 0) {
        isChecked = true;
      }

      // Toggle partial state based on cascade model
      if (checked === 2) {
        isChecked = optimisticToggle;
      }

      onCheck({
        value: value,
        checked: isChecked,
        entity: entity,
        children: rawChildren
      });
    }
  }, {
    key: 'onExpand',
    value: function onExpand() {
      var _props2 = this.props,
          expanded = _props2.expanded,
          entity = _props2.entity,
          value = _props2.value,
          onExpand = _props2.onExpand;


      onExpand({
        expanded: !expanded,
        value: value,
        entity: entity
      });
    }
  }, {
    key: 'hasChildren',
    value: function hasChildren() {
      return this.props.rawChildren !== null;
    }
  }, {
    key: 'renderExpandCollapseButton',
    value: function renderExpandCollapseButton() {
      var _props3 = this.props,
          expanded = _props3.expanded,
          forceShowToggleIcon = _props3.forceShowToggleIcon;

      var iconSize = '10';

      if (!this.hasChildren() && !forceShowToggleIcon) {
        return _react2.default.createElement('div', { style: { width: iconSize + 'px', height: iconSize + 'px' } });
      }

      return _react2.default.createElement(_icon2.default, {
        name: expanded ? 'arrow-down' : 'arrow-right',
        size: iconSize,
        color: 'light',
        onClick: this.onExpand
      });
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      var _props4 = this.props,
          checked = _props4.checked,
          disabled = _props4.disabled,
          entity = _props4.entity,
          label = _props4.label,
          value = _props4.value,
          showCheckbox = _props4.showCheckbox;


      return _react2.default.createElement(
        'label',
        { className: 'tree-node__label', onDoubleClick: this.onExpand },
        showCheckbox && _react2.default.createElement(_checkbox2.default, {
          className: 'tree-node__checkbox',
          value: value,
          checked: checked === 1,
          indeterminate: checked === 2,
          disabled: disabled,
          onChange: this.onCheck
        }),
        typeof label === 'function' ? label(entity) : label
      );
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      if (!this.props.expanded) {
        return null;
      }

      return this.props.children;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          className = _props5.className,
          disabled = _props5.disabled,
          depth = _props5.depth;

      var nodeClass = (0, _index.cn)('tree-node', disabled && 'tree-node--disabled', className);

      return _react2.default.createElement(
        'li',
        { className: nodeClass, style: { paddingLeft: depth * 20 + 'px' } },
        _react2.default.createElement(
          'span',
          { className: 'tree-node__header' },
          this.renderExpandCollapseButton(),
          this.renderLabel()
        ),
        this.renderChildren()
      );
    }
  }]);

  return TreeNode;
}(_react2.default.Component);

var treeNodeBaseProps = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,

  entity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.object]),
  forceShowToggleIcon: _propTypes2.default.bool,
  showCheckbox: _propTypes2.default.bool
};

var treeNodeProps = exports.treeNodeProps = _propTypes2.default.oneOfType([_propTypes2.default.shape(treeNodeBaseProps), _propTypes2.default.shape(_extends({}, treeNodeBaseProps, {
  children: _propTypes2.default.arrayOf(treeNodeBaseProps).isRequired
}))]);

TreeNode.propTypes = _extends({}, treeNodeBaseProps, {
  checked: _propTypes2.default.number.isRequired,
  depth: _propTypes2.default.number,
  disabled: _propTypes2.default.bool.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  optimisticToggle: _propTypes2.default.bool.isRequired,
  onCheck: _propTypes2.default.func.isRequired,
  onExpand: _propTypes2.default.func.isRequired,

  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  rawChildren: _propTypes2.default.arrayOf(treeNodeProps),
  showCheckbox: _propTypes2.default.bool
});

TreeNode.defaultProps = {
  children: null,
  className: null,
  depth: 0,
  icon: null,
  rawChildren: null,
  forceShowToggleIcon: false,
  showCheckbox: true
};

exports.default = TreeNode;